import React from "react";
import "../../styles/footer.css";
import LogoWhite from "../../img/logoWhite.png";
import localizationIcon from "../../img/localizacao/localizacaoOne.png"; // Importando o ícone de localização
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo e Endereço */}
        <div className="footer-logo-endereco">
          <img src={LogoWhite} alt="Mediacao Logo" className="footer-logo" />
          <p className="footer-endereco">
            <a
              href="https://www.google.com/maps?q=Rua+Quinze+de+Janeiro,+121"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center", gap: "8px", textDecoration: "none", color: "inherit" }}
            >
              <strong>Rua Quinze de Janeiro, 121</strong>
              <img src={localizationIcon} alt="Localização" className="footer-localizacao-icon" />
            </a>

            Centro - Canoas / RS 92010-300
          </p>
        </div>

        <div className="alemDaClinica">
          <h2><b>Conheça-nos</b></h2>
          <Link to="/clinica" className="ClinicaDirecionamento">Clinica</Link> <br />
          <Link to="/livros" className="ClinicaDirecionamento">Livros</Link> <br />
          {/*<Link to="/alemDaClinica" className="ClinicaDirecionamento">Palestras</Link><br/>*/}
          <Link to="/denuncia" className="ClinicaDirecionamento">Canal de Denúncia</Link>
        </div>

        {/* Contato e redes sociais */}
        <div className="footer-contato-redes">
          <div className="footer-contato-redes">
            <div className="footer-contato">
              <h4><b>Fale Conosco</b></h4>

              {/* Telefone Fixo - Modo Ligação */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                margin: '0.5rem 0'
              }}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="#ffffff"
                  style={{ flexShrink: 0, opacity: 0.8 }}
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                <a
                  href="tel:555134726896"
                  style={{
                    color: 'inherit',
                    textDecoration: 'none',
                    cursor: 'pointer'
                  }}
                >
                  (51) 3472-6896
                </a>
              </div>

              {/* WhatsApp */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                margin: '0.5rem 0'
              }}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="#ffffff"
                  style={{ flexShrink: 0 }}
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                <a
                  href="https://api.whatsapp.com/send?phone=5551999339942&text=Ol%C3%A1%20gostaria%20de%20agendar%20uma%20consulta,%20pode%20me%20auxiliar?"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: 'inherit',
                    textDecoration: 'none'
                  }}
                >
                  (51) 99933-9942
                </a>
              </div>

              <a href="mailto:clinicamediacao@gmail.com.br"><b>clinicamediacao@gmail.com.br</b></a>
            </div>
          </div>
          <div className="footer-redes">
            <h4>Nossas Redes Sociais</h4>
            <div className="redes-icones">
              <a href="https://www.instagram.com/clinica_mediacao/" target="blank" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/mediacaocentrodeterapiasintegradas/?locale=pt_BR" target="blank" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              {/*<a href="#" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>*/}
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          Mediação Centro de Terapias Integradas &copy; {new Date().getFullYear()} - Todos os Direitos Reservados
        </p>
      </div>

    </footer>
  );
};

export default Footer;
